// Avoid having an export on the first line for istanbul

export const MAX_PAGE_SIZE = 500;
